import { reviews } from "@/mocks/testimonials";
import SectionHeading from "./SectionHeading";

const PRINCIPLES = [
  {
    icon: "ri-flag-2-line",
    title: "先标信息，再谈立场",
    desc: "每条时间线都区分「已确认」「双方说法」「尚未证实」，我们只做整理，不对任何一方下结论。",
  },
  {
    icon: "ri-file-search-line",
    title: "溯源与交叉核对",
    desc: "节点必须能追到原始出处，同一信息尽量用两路独立信源交叉印证，拿不准就明确标注待证实。",
  },
  {
    icon: "ri-loop-left-line",
    title: "有反转就更新，不假装没看见",
    desc: "事件出新进展或反转时，我们会在时间线补更新节点，也会保留此前的说法脉络，让变化可见。",
  },
];

export default function About() {
  return (
    <section id="about" className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="关于平台"
          title="我们是谁，为什么做这件事"
          description="「瓜记」是一个面向大众的网络热点事件时间线整理平台。我们相信：吃瓜不该是一次次被带节奏的情绪消耗，而可以变成一次清晰、中立的公共信息理解。"
        />

        <div className="mt-10 grid gap-6 lg:grid-cols-[1fr_1.4fr]">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-2xl font-bold text-background-50">
                瓜
              </span>
              <div>
                <div className="font-heading text-xl font-bold text-foreground-900">瓜记 GuaJi</div>
                <div className="text-xs text-foreground-500">全网吃瓜 · 事件时间线整理站</div>
              </div>
            </div>

            <p className="mt-6 text-sm leading-loose text-foreground-700">
              全网每天都有新的「瓜事」冒出来：起因往往很短，发酵却铺得很长。我们的工作，就是把这些散落在各平台、真假混杂的信息，按真实的时间顺序整理成一条可读的线，把完整经过与来龙去脉讲清楚。
            </p>
            <p className="mt-3 text-sm leading-loose text-foreground-700">
              网站会长期开放，热榜按讨论热度实时排序，重点事件进入深度时间线持续跟进。我们的内容不追求流量式的极端，只希望在你需要快速看懂一件复杂瓜事时，能一站给到你需要的脉络。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {["中立整理", "开放校对", "信息标注", "持续更新"].map((t) => (
                <span
                  key={t}
                  className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-1">
            {PRINCIPLES.map((p) => (
              <div key={p.title} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                  <i className={p.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 md:text-lg">{p.title}</h3>
                  <p className="mt-1 text-[13px] leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* reviews */}
        <div className="mt-12">
          <div className="flex items-end justify-between">
            <div>
              <div className="flex items-center gap-2 text-primary-600">
                <span className="inline-block h-px w-6 bg-primary-500" />
                <span className="text-sm font-semibold tracking-wide">用户口碑</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold text-foreground-900 md:text-2xl">
                看过的人怎么说
              </h3>
            </div>
            <div className="hidden items-center gap-1 text-accent-600 sm:flex" aria-label="评分 4.8 / 5">
              {[1, 2, 3, 4, 5].map((n) => (
                <i key={n} className="ri-star-fill" />
              ))}
              <span className="ml-1 text-sm font-semibold text-foreground-800">4.8 / 5</span>
            </div>
          </div>

          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            {reviews.map((r) => (
              <figure key={r.id} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                <div className="flex gap-0.5 text-accent-500">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <i key={n} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">「{r.text}」</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                    {r.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{r.name}</div>
                    <div className="text-xs text-foreground-500">{r.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}